// Each window can optionall have tabs. Each tab holds a react component that is rendered inside of it.
// The context is used to keep track of the curren windows and tabs
//
//
// global context = Window[]
//
// Window = Tab[] | React.ReactNode
// Tab = React.ReactNode

import type React from "react";
import { useState } from "react";
import type { IconBaseProps } from "react-icons/lib";
import { LuX } from "react-icons/lu";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@acme/ui/tabs";

export interface Tab {
	title?: string;
	icon?: (props: IconBaseProps) => React.ReactNode;
	content: React.ReactNode;
}

export interface WindowProps {
	tabs: Record<string | number, Tab>;
	defaultSelected?: string;
	onClose?: (tabId: string) => void;
	children: React.ReactNode[] | React.ReactNode;
	selectedFile?: string;
	setSelectedFile: (file: string) => void;
}

export const Window: React.FC<
	WindowProps & React.HTMLAttributes<HTMLDivElement>
> = ({
	tabs,
	children,
	defaultSelected,
	onClose,
	selectedFile,
	setSelectedFile,
}) => {
	return (
		<>
			<div className="bg-muted border-b border-border text-white flex items-center justify-start flex flex-row gap-3 rounded-t-lg">
				{Object.entries(tabs).map(([tabId, tab], key) => (
					<button
						type="button"
						key={`${tabId}`}
						onClick={() => setSelectedFile(tabId)}
						className={`py-4 text-l px-1 flex flex-row gap-2 transition duration-150 border-b-2 items-center ${selectedFile === tabId ? "border-primary" : "border-transparent hover:border-secondary"}`}
					>
						{tab.icon && <span className="mr-1">{tab.icon({ size: 2 })}</span>}
						{tab.title ?? tabId}
						<button
							type="button"
							className="hover:bg-destructive"
							onClick={(event) => {
								event?.preventDefault();
								event?.stopPropagation();
								onClose?.(tabId);
							}}
						>
							<LuX size={16} />
						</button>
					</button>
				))}
			</div>
			{children}
		</>
	);
};
